import React from "react"
import AuthGate from "./../components/authgate"
import i18n from '../i18n';

const IndexPage = ({ location }) => {
  return <AuthGate location={location} />
}

export default IndexPage
